import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Box, Button } from '@mui/material';

/*  Shared  */
import { URLs } from 'application/Shared/Constants';
import { formatDistanceToNow } from 'application/Shared/Helpers/Dates';
import ClassNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  FileBrowser  */
import { getExtensionMapping } from './Constants';
import { fileSize } from './Utils';

export const TableFile = ({
    browserProps,
    depth,
    fileKey,
    isSelected,
    modified,
    newKey,
    size,
    url
}) => {
    const { t } = useTranslation();

    const getName = () => {
        let name = newKey || fileKey;
        const slashIndex = name.lastIndexOf('/');
        if (slashIndex !== -1) {
            name = name.substr(slashIndex + 1);
        }
        return name;
    };

    const getExtension = () => {
        const blobs = fileKey.split('.');
        return blobs[blobs.length - 1].toLowerCase().trim();
    };

    const getFileType = () => {
        const mapping = getExtensionMapping();
        const extension = getExtension();
        return mapping[extension] || 'File';
    };

    const handleFileClick = (event) => {
        if (event) {
            event.preventDefault();
        }
        browserProps.preview({
            extension: getExtension(),
            key: fileKey,
            name: getName(),
            url
        });
    };

    const handleItemClick = (event) => {
        event.stopPropagation();
        browserProps.select(
            fileKey,
            'file',
            event.ctrlKey || event.metaKey,
            event.shiftKey
        );
    };

    const fileURL = `${URLs.salesDocs}/salesDocs${fileKey}`;

    const icon = browserProps.icons[getFileType()] || browserProps.icons.File;

    return (
        <tr
            className={ClassNames('file', {
                selected: isSelected
            })}
            onClick={handleItemClick}
        >
            <td className="name">
                <div style={{ paddingLeft: `${depth * 16}px` }}>
                    <Box
                        as="a"
                        href={url || '#'}
                        download="download"
                        onClick={handleFileClick}
                    >
                        <Box alignItems="center" display="flex">
                            <Box mr="8px">{icon}</Box>
                            {getName()}
                        </Box>
                    </Box>
                </div>
            </td>
            <td className="size">{fileSize(size)}</td>
            <td className="modified">
                {typeof modified === 'undefined'
                    ? '-'
                    : formatDistanceToNow(modified)}
            </td>
            <td className="actions" style={{ textAlign: 'right' }}>
                <a
                    href={fileURL}
                    download
                    data-trackid="fileBrowser_download_routeTo"
                >
                    <Button
                        data-trackid="fileBrowser_download"
                        variant="outlined"
                        size="anmSmall"
                        color="primary"
                    >
                        <FileDownloadIcon
                            fontSize="small"
                            style={{ marginRight: '8px' }}
                        />
                        {t('Common.download')}
                    </Button>
                </a>
            </td>
        </tr>
    );
};
